import { Component, OnInit, OnDestroy, ViewChild, Inject, ElementRef } from '@angular/core';
import { Cliente } from 'src/app/models/cliente';
import { Filtro } from 'src/app/models/filtro';
import { MatPaginator, PageEvent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ClienteService } from 'src/app/services/cliente.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Router } from '@angular/router';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import swal from 'sweetalert2';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { PerfilDoUsuario, TipoArquivo } from 'src/app/models/enum';
import { GlobalService } from 'src/app/services/global.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { PaginatorService } from 'src/app/services/paginator.service';
import { FinanciamentoService } from 'src/app/services/financiamento.services';
import { IntegradorFinanciadoraSimples } from 'src/app/models/financiamento/integrador-financiadora-simples';
import { ArquivoService } from 'src/app/services/arquivo.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-clientes-modal',
  templateUrl: './clientes-modal.component.html',
  styleUrls: ['./clientes-modal.component.scss']
})
export class ClientesModalComponent implements OnInit, OnDestroy {
  PerfilDoUsuario = PerfilDoUsuario;
  perfil: PerfilDoUsuario;
  administrador = false;

  // variáveis
  clientesFiltrados: Cliente[] = [];
  carregando = true;
  campoOrdenacao = 'fantasia';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  status = [{ id: false, nome: 'Pendente' }, { id: true, nome: 'Já Cliente' }];
  statusSelecionado = -1;

  tiposDeStatus = [{ id: -1, nome: 'Todos' }, { id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];

  gi = 1;
  esconderBotao = false;
  tiposPesquisa =
    [
      { id: 0, nome: 'Documento' },
      { id: 1, nome: 'Fantasia' },
      { id: 2, nome: 'Razão' },
      { id: 3, nome: 'Email' }
    ];

  tipoPesquisaSelecionado: number;
  pesquisa: string;

  pesquisaGeral = false;

  pesquisarPorVendedor: false;
  idVendedor;

  limDesc = undefined;

  vendedores = [];

  public config: PerfectScrollbarConfigInterface = {};

  usuarioLogado: UsuarioLogado;

  financiamento = false;

  tipoSituacaoBancoFinancimento = [{ id: -1, nome: 'Todos' }, { id: 1, nome: 'Sim' }, { id: 0, nome: 'Não' }];
  tipoSituacaoBancoFinancimentoSelecionada = -1;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private funcionarioService: FuncionarioService, private globalService: GlobalService, private clienteService: ClienteService, public utilitarioService: UtilitarioService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private paginatorService: PaginatorService,
    public dialogRef: MatDialogRef<ClientesModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private hierarquiaService: CRMHierarquiaUsuarioService,
    private financiamentoService: FinanciamentoService, private arquivoService: ArquivoService) { }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.administrador = await this.globalService.administrador();
    this.perfil = await this.globalService.perfil();
    this.pesquisaGeral = this.data.pesquisaGeral;
    this.gi = this.data.gi;
    this.pesquisarPorVendedor = this.data.pesquisarPorVendedor;
    this.idVendedor = this.data.idVendedor;

    if (this.pesquisaGeral) {
      this.tiposPesquisa = [...this.tiposPesquisa,
        { id: 4, nome: 'Telefone' },
        { id: 5, nome: 'Cidade' }
      ];
    }

    this.esconderBotao = this.data.esconderBotao;

    this.financiamento = this.data.financiamento;

    const filtroNomeCliente = document.getElementById('filtroNomeCliente');

    setTimeout(() => {
      filtroNomeCliente.focus();
    }, 500);

    if (!this.pesquisaGeral && (this.perfil === PerfilDoUsuario.Suporte || this.perfil === PerfilDoUsuario.Administrador || this.perfil === PerfilDoUsuario.Vendedor)) {
      if (this.idVendedor === null || this.idVendedor === undefined) {
        this.idVendedor = this.usuarioLogado.id;
      }

      if (this.idVendedor) {
        this.buscarDescontoPorVendedor();
      }

      this.buscarVendedores();
    }
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarClientes();
    this.paginator.firstPage();
  }

  buscarVendedores() {
    if (this.administrador) { //|| !this.usuarioLogado.verSomenteHierarquia) {
      this.carregandoService.mostra('buscarVendedores');

      this.funcionarioService.consultarFuncionariosPedido().subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));

        if (this.vendedores.length > 1) {
          this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
        }

        this.carregandoService.esconde('buscarVendedores');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      });
    }
    else {
      this.carregandoService.mostra('buscarVendedoresHierarquia');

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
        this.vendedores = resp;

        if (this.vendedores.some(p => p.idFuncion === Number(this.usuarioLogado.id))) {
          this.vendedores.splice(this.vendedores.
            indexOf(this.vendedores.find(p => p.idFuncion === Number(this.usuarioLogado.id))), 1);
        }

        if (this.vendedores.length > 0) {
          const todos = new CRMHierarquiaUsuario();
          todos.idFuncion = 0;
          todos.nome = 'Todos';
          this.vendedores.unshift(todos);
        }

        const somenteEu = new CRMHierarquiaUsuario();
        somenteEu.idFuncion = this.usuarioLogado.id;
        somenteEu.nome = 'Somente eu';
        this.vendedores.unshift(somenteEu);

        this.carregandoService.esconde('buscarVendedoresHierarquia');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedoresHierarquia');
        this.notificacaoService.erro(erro);
      });
    }
  }

  buscarClientes() {
    if (this.idVendedor) {
      this.buscarDescontoPorVendedor();
    }

    this.carregandoService.mostra('buscaClientes');

    this.clienteService.consultarClientesComPaginacao(this.filtroNome.Valor, this.gi === 0 || this.pesquisaGeral ? (this.statusSelecionado === -1 ? undefined : this.statusSelecionado) : 1, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.gi, this.tipoPesquisaSelecionado, this.pesquisa, this.idVendedor !== undefined && this.idVendedor !== null, this.idVendedor === 0 ? null : this.idVendedor, this.pesquisaGeral, this.financiamento && this.tipoSituacaoBancoFinancimentoSelecionada > -1 ? this.tipoSituacaoBancoFinancimentoSelecionada : null).subscribe(dados => {
        this.clientesFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;

        if (this.financiamento) {
          this.clientesFiltrados.filter(p => !this.bloqueadoFinanciamento(p)).forEach(p => this.buscarFinanciadoras(p));
        }

        this.carregandoService.esconde('buscaClientes');
      }, (erro) => {
        this.carregandoService.esconde('buscaClientes');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarClientes();
  }

  retornaPerfil(perfil) {
    switch (perfil) {
      case 1:
        return 'Op';

      case 2:
        return 'Ad';

      default:
        break;
    }
  }

  retornaClassePerfil(perfil) {
    switch (perfil) {
      case 1:
        return 'badge-primary';

      case 2:
        return 'badge-info';

      default:
        break;
    }
  }

  bloqueadoFinanciamento(cliente: Cliente): boolean {
    return !!this.financiamento && cliente.podeVerFinanciamento === false;
  }

  selecionaCliente(cliente) {
    // Integrador bloqueado para financiamento aparece na busca, mas não pode ser selecionado.
    if (this.bloqueadoFinanciamento(cliente)) {
      return;
    }

    if (this.gi === 1 && !this.pesquisaGeral) {
      this.dialogRef.close(
        {
          cliente,
          vendedor: this.idVendedor ? this.vendedores.find(p => p.idFuncion === this.idVendedor) : undefined,
          limDesc: this.limDesc
        }
      );
    }
  }

  buscarDescontoPorVendedor() {
    this.carregandoService.mostra('buscarDescontoPorVendedor');

    this.funcionarioService.consultarLimitDesc(this.idVendedor).subscribe(
      result => {
        this.limDesc = result;
        this.carregandoService.esconde('buscarDescontoPorVendedor');
      },
      err => {
        this.carregandoService.esconde('buscarDescontoPorVendedor');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void { }

  transformarEmCliente(cliente: Cliente) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente transformar esse cliente em integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.router.navigateByUrl('/integradores/novo', { state: { idCliente: cliente.id } });
        this.fechar();
      }
    });
  }

  buscarFinanciadoras(cliente: Cliente) {
    this.carregandoService.mostra('buscarFinanciadoras');
    this.financiamentoService.consultarFinanciadorasParaIntegrador(cliente.id, false).subscribe(dados => {
      cliente.financiadoras = dados;

      cliente.financiadoras.forEach(p => {
        this.buscarImagem(p);
      });

      this.carregandoService.esconde('buscarFinanciadoras');
    }, (erro) => {
      this.carregandoService.esconde('buscarFinanciadoras');
      this.notificacaoService.erro(erro);
    });
  }

  buscarImagem(financiadora: IntegradorFinanciadoraSimples) {
    try {
      financiadora.imagem$ = this.arquivoService.baixarArquivo(financiadora.idFinanciadora, TipoArquivo.FinanciadoraImagem)
        .map(m => this.utilitarioService.toBase64ComInicio(m)).toPromise();
      financiadora.imagem$.then(p => { financiadora.buscouImagem = true; }).catch(p => { financiadora.semImagem = true; });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }
}
